import {Fragment, useEffect, useRef, useState} from 'react';
import {AiOutlineMinus, AiOutlinePlus} from '@assets/react-icons/ai';

export function SingleProductFocusVerticalTabs({tabNames, sections, showDescription}) {
  const [openTabs, setOpenTabs] = useState(['Description', `Bundle Items (What's Included)`]);
  const tabRefs = useRef([]);
  const [heights, setHeights] = useState([]);

  useEffect(() => {
    setHeights(tabRefs.current.map((tabRef) => tabRef.clientHeight + 32));
  }, [sections]);

  const handleTabClick = (index) => {
    const isTabOpen = openTabs?.includes(index) ? true : false;

    const newOpen = isTabOpen ? openTabs?.filter((x) => x !== index) : [...openTabs, index];

    setOpenTabs(newOpen);
  };

  return (
    <div>
      {tabNames.map((item, index) => {
        const isTabOpen = openTabs?.includes(item) ? true : false;
        let newHeight = heights[index] || 'auto';
        if (item === 'Media') {
          newHeight = 'auto';
        }

        return (
          <Fragment key={item}>
            <div className='duration-400 ease-out first:border-t border-neutral-400 text-black'>
              <button
                onClick={() => handleTabClick(item)}
                className='py-3 px-4 lg:px-0 flex w-full items-center justify-between'>
                <div className='font-oswald tracking-widest uppercase'>{item}</div>
                <div>{isTabOpen ? <AiOutlineMinus size={16} /> : <AiOutlinePlus size={16} />}</div>
              </button>
            </div>
            <div
              className='border-neutral-400 border-b duration-300 overflow-hidden custom-transition'
              style={{
                height: isTabOpen ? newHeight : '0px'
              }}>
              <div
                ref={(el) => (tabRefs.current[index] = el)}
                id={`desc-${item}`}
                className='pb-4 px-4 lg:px-0'>
                {sections[index]}
              </div>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
